/*eslint-disable*/
export default {
    methods: {
        difficultyStringified(difficult) {
            let difficultyString = '';
            if (difficult.digits) {
                difficultyString += `0-${difficult.digits.length}`;
            }
            if (difficult.thousands) {
                difficultyString ?
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity4')
                      + ' (' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_thousands') + ') '
                      + `1000-${difficult.digits.length}000` :
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity4')
                      + ' (' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_thousands') + ') 1000-9000';
            } else if (difficult.hundreds) {
                difficultyString ?
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity3')
                      + ' (' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_hundreds')
                      + `) 100-${difficult.digits.length}00` :
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity3')
                      + ' (' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_hundreds') + ') 100-900';
            } else if (difficult.tens) {
                difficultyString ?
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity2')
                      + '(' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_tens')
                      + `) 10-${difficult.digits.length}0` :
                    difficultyString = this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity2')
                      + ' (' + this.$i18n.t('fleshCardsPreview.fleshCardsPreview_digitCapacity_tens') + ') 10-90';
            } else if (difficult.fiveDigit) {
                difficultyString += this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity5') + ' 10000-99999';
            } else if (difficult.fourDigit) {
                difficultyString += this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity4') + ' 1000-9999';
            } else if (difficult.threeDigit) {
                difficultyString += this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity3') + ' 100-999';
            } else if (difficult.twoDigit) {
                difficultyString += this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity2') + ' 10-99';
            } else if (difficult.teens) {
                difficultyString += this.$i18n.t('fleshCardsPreview.fleshCardsPreview_preview_digitCapacity2') + ' 10-19';
            }
            return difficultyString;
        }
    }
}